import { createReducer } from '@reduxjs/toolkit';
import {
  setManufacturers,
  setMaxPrice,
  setMinPrice,
  setSearchText,
} from '../Actions/SearchActions';
import { SelectOption } from '../Models/SelectOption';

type SearchRequestReference = {
  searchTextState: string | null;
  manufacturersState: SelectOption[] | null;
  minPriceState: number | null;
  maxPriceState: number | null;
};

const initialState: SearchRequestReference = {
  searchTextState: '',
  manufacturersState: null,
  minPriceState: null,
  maxPriceState: null,
};

const SearchReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setSearchText, (state, action) => {
      return { ...state, searchTextState: action.payload };
    })
    .addCase(setManufacturers, (state, action) => {
      return { ...state, manufacturersState: action.payload };
    })
    .addCase(setMinPrice, (state, action) => {
      return { ...state, minPriceState: action.payload };
    })
    .addCase(setMaxPrice, (state, action) => {
      return { ...state, maxPriceState: action.payload };
    });
});

export default SearchReducer;
